module.exports = "/_next/static/images/Johnathan_Doyle-a77109e5bedcae2fb6e99f3ad53d3ae3.webp";